import { lazy } from 'react';
export var TaskPageAsync = lazy(function () { return import('./TaskPage'); });
